// extracted by mini-css-extract-plugin
export default {"section2":"ProfileContainer_section2__HBg86"};